export class DossierInterventionActiviteEau {
    id: number;
    etage_id: number;
    piece_id: number;
    dossier_intervention_id: number;
    public constructor(init?: Partial<DossierInterventionActiviteEau>) {
      Object.assign(this, init);
    }
  }
